import { getLoadable } from '@ge/shared/util';

// Define the available pages for lazy loading.
export const loadables = {
  issues: getLoadable(() => import('./issues')),
  assets: getLoadable(() => import('./assets')),
  reports: getLoadable(() => import('./reports')),
  sites: getLoadable(() => import('./sites')),
};

export const mobileLoadables = {
  // casesTasks: getLoadable(() => import('./mobile/cases-tasks')),
  sites: getLoadable(() => import('./mobile/sites')),
};

// @index('./**/*.jsx', f => `export * from '${f.path}';`)
export * from './assets';
export * from './issues';
export * from './reports';
export * from './sites';
export * from './mobile/sites';
// export * from './mobile/cases-tasks';
export * from './mobile/sites';
// @endindex
